<template>
    <v-modal-confirmed accept-button-text="Borrar"
                       close-button-text="Cancelar"
                       title="Borrar usuario"
                       confirm-modal-accept-button-text="Sí"
                       confirm-modal-close-button-text="No"
                       content="¿Estás seguro?"
                       confirm-modal-title="Confirmar..."
                       @closed="closeModal"
                       @accepted="deleteUser">
        <span>¿Seguro que quieres eliminar este usuario?</span>
        <div class="user-name">{{ user.name }}</div>
    </v-modal-confirmed>
</template>

<script>
import {deleteUser} from "../../../helpers/requests/RequestsUsers";
import VModalConfirmed from "../../general/VModalConfirmed";

export default {
    name: "UsersListDeleteModal",
    components: {VModalConfirmed},
    props: ['user'],
    methods: {
        async deleteUser() {
            try {
                await deleteUser(this.user);

                this.$store.dispatch('app/setToastMessage', 'Usuario eliminado');

                this.closeModal();

            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al eliminar el usuario');
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
